import * as actionTypes from '../actions/actionTypes';

export const fetchNotifications = (data) => {
    return {
        type: actionTypes.FETCH_NOTIFICATIONS,
        data
    }
}
export const createNotification = (data) => {
    return {
        type: actionTypes.CREATE_NOTIFICATION,
        data
    }
}
export const deleteNotification = (id) => {
    console.log(id);
    return {
        type: actionTypes.DELETE_NOTIFICATION,
        id
    }
}
export const updateNotification = (id) => {
    return {
        type: actionTypes.UPDATE_NOTIFICATION,
        id
    }
}
export const clearNotifications = () => {
    return {
        type: actionTypes.CLEAR_NOTIFICATIONS
    }
}